// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import plugins from './plugins';
import views from './views';
import storage from './storage';

export default {
    views,
    plugins,
    storage
};



// WEBPACK FOOTER //
// ./reducers/index.js